import {stateData, reduxState} from '../../values';

export const getHistory = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_history,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updateHistory = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_history,
            payload:    data,
        })
    }
}